(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function bindMessageCloseButtons(root) {
    root = root || document;
    // Ensure each .messages block has a visible close button and bind it.
    var wrappers = root.querySelectorAll('.messages');
    wrappers.forEach(function (wrapper) {
      if (!wrapper) return;
      var btn = wrapper.querySelector('.messages__close');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'messages__close';
        btn.setAttribute('aria-label', 'Cerrar mensaje');
        btn.innerHTML = '&times;';
        wrapper.insertBefore(btn, wrapper.firstChild);
      }
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // small fade out then remove
        wrapper.style.transition = 'opacity 0.18s ease, transform 0.18s ease';
        wrapper.style.opacity = '0';
        wrapper.style.transform = 'translateY(-6px)';
        setTimeout(function () { if (wrapper && wrapper.parentNode) wrapper.parentNode.removeChild(wrapper); }, 190);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindMessageCloseButtons(document);
  });

  // If messages are injected later via AJAX, observe container
  var observerRoot = document.querySelector('[data-drupal-messages]');
  if (observerRoot) {
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { bindMessageCloseButtons(m.target); });
    });
    mo.observe(observerRoot, { childList: true, subtree: true });
  }
})();
